import { render, staticRenderFns } from "./ShiftCalendar.vue?vue&type=template&id=2db4e789&scoped=true"
import script from "../../scripts/pages/ShiftCalendar.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/ShiftCalendar.js?vue&type=script&lang=js&external"
import style0 from "./ShiftCalendar.vue?vue&type=style&index=0&id=2db4e789&prod&scoped=true&lang=css"
import style1 from "./ShiftCalendar.vue?vue&type=style&index=1&id=2db4e789&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4e789",
  null
  
)

export default component.exports